
import { Component, Vue } from 'vue-property-decorator';
import Upload from '@/components/ImagesUpload/upload.vue';
import PrizeList from './components/_PrizeList.vue';
import TaskItem from './components/_TaskItem.vue';
import Preview from './components/_Preview.vue';
import { eRewardType, eTaskType, iCheckIn, iDailyCheckInSetting } from '@/interface/prize';
import { getPrizeInfo, postPrizeInfo } from '@/api/prize';
import { day, toast } from '@/utils/common';
import { VueEditor } from 'vue2-editor';
import LogUtils from 'panda-log';
import { UserModule } from '@/store/modules/user';
@Component({
  components: { Upload, PrizeList, TaskItem, Preview, VueEditor },
})
export default class index extends Vue {
  loading: boolean = false;
  name: string = '';

  isPreviewVisible: boolean = false;
  activeTaskCollapse: string[] = ['1'];

  model: iCheckIn = {
    daily_check_in_settings: [],
    activity_rules: '',
  };
  preViewModel: any = {};
  prizeList: iDailyCheckInSetting[] = [];
  activeBrand: string = UserModule.activeBrand;
  prizeType: object[] = [
    // { id: eRewardType.NO, value: RewardTypes[eRewardType.NO] },
    { id: eRewardType.IOS, value: '体验时长' },
    // { id: eRewardType.CASH, value: RewardTypes[eRewardType.CASH] },
    // { id: eRewardType.WEEKCARD, value: RewardTypes[eRewardType.WEEKCARD] },
    // { id: eRewardType.COIN, value: this.activeBrand === 'lingwoyun' ? RewardTypes[eRewardType.COIN] : '桃币' },
  ];
  taskType = [
    { id: eTaskType.NO, value: '请选择任务类型' },
    { id: eTaskType.TOTALTIMES, value: '当日累积连接时长' },
    { id: eTaskType.DAYTOTALMONEY, value: '当日累积充值金额' },
    { id: eTaskType.PANGOLIN, value: '穿山甲任务' },
  ];
  taskModel: object = {
    id: 0,
    task_type: eTaskType.NO,
    task_consumables: null,
    frequency: 1, //每日参与
    task_name: '',
    task_explain: '',
    sort: 0,
    task_prize: {
      day_sum: 0,
      reward_name: '',
      reward_type: eRewardType.IOS,
      consumables: null,
    },
    task_extend: {},
  };
  rules = {
    prize: [{ required: true, validator: this.validPrize, trigger: 'blur' }],
    // taskSetting: [{ required: true, validator: this.validTaskSetting, trigger: 'blur' }],
    activity_rules: [{ required: true, message: '请输入活动规则文字', trigger: 'blur' }],
  };
  customToolbar = [
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
    [{ color: [] }],
    [{ indent: '-1' }, { indent: '+1' }],
  ];

  PrizeList: any;
  TaskItem: any;
  Preview: any;
  vueEditor: any;

  setPrizeList() {
    // day_sum_value: `第${day[i]}天`,
    this.prizeList = this.model.daily_check_in_settings;
    if (this.prizeList.length <= 0) {
      for (let i = 0; i < 7; i++) {
        this.prizeList.push({
          day_sum: i + 1,
          reward_name: '',
          reward_type: eRewardType.IOS,
          consumables: null,
        });
      }
    }
  }

  //验证奖品
  validPrize(rule: any, value: any, callback: any) {
    let error = '';
    this.prizeList.forEach((item: iDailyCheckInSetting, index: number) => {
      const consumables = item.consumables;
      item.reward_type = eRewardType.IOS;

      if (!consumables) {
        error += '第' + day[index] + '天奖品配置有误！';
      } else {
        item.consumables = JSON.parse(consumables + '');
        item.reward_name = consumables + ' min game time';
      }
    });
    if (error.length > 0) {
      return callback(new Error(error));
    }
    this.model.daily_check_in_settings = this.prizeList;

    return callback();
  }

  submitForm(formName: string, type: number) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        if (type == 1) {
          this.$msgbox({
            title: '提示',
            message: '确认提交吗？',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            beforeClose: async (action, instance, done) => {
              if (action === 'confirm') {
                this.addPrize();
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = '执行中...';
                done();
                instance.confirmButtonLoading = false;
              } else if (action === 'cancel') {
                instance.confirmButtonLoading = false;
                done();
              }
            },
          }).catch((err: any) => {
            console.log(err, '错误');
          });
        } else {
          // this.isPreviewVisible = true;
          // this.preViewModel = JSON.parse(JSON.stringify(this.model));
          // this.preViewModel.welfare_task_settings.push({
          //   id: 888,
          //   task_type: eTaskType.NO,
          //   task_consumables: null,
          //   frequency: 1, //每日参与
          //   task_name: '邀请好友注册',
          //   task_explain: '',
          //   sort: 0,
          //   task_prize: {
          //     day_sum: 0,
          //     reward_name: '邀请人和受邀人均+30云币',
          //     reward_type: eRewardType.IOS,
          //     consumables: null,
          //   },
          // });
        }
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  async addPrize() {
    const res = await postPrizeInfo(this.model);
    if (res.code == 0) {
      toast('保存成功！');
      this.getList();
    } else {
      toast(res.msg, 'error');
    }
  }
  async getList() {
    try {
      const res = await getPrizeInfo();

      if (res.data != null) {
        // this.model = res.data;
        this.model.daily_check_in_settings = res.data.daily_check_in_settings;
        this.model.activity_rules = res.data.activity_rules;
      }
    } catch (ex) {
      LogUtils.info(ex);
    } finally {
      this.setPrizeList();
    }
  }
  mounted() {
    //获取数据
    this.getList();
  }
}
